import type { Template } from "@/types";

export const LA_06_H4_V2: Template[] = [
    {
        id: "la-06-h4v2-01",
        name: "LA 01 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_01.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 96, y: 56, width: 484, height: 305, rotation: 0, imageRotation: 0 },
            { id: "2", x: 96, y: 369, width: 156, height: 116, rotation: 0, imageRotation: 0 },
            { id: "3", x: 260, y: 369, width: 156, height: 116, rotation: 0, imageRotation: 0 },
            { id: "4", x: 424, y: 369, width: 156, height: 116, rotation: 0, imageRotation: 0 },
            { id: "5", x: 740, y: 56, width: 271, height: 428, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1019, y: 56, width: 270, height: 428, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h4v2-02",
        name: "LA 02 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_02.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 95, y: 50, width: 481, height: 281, rotation: 0, imageRotation: 0 },
            { id: "2", x: 95, y: 339, width: 237, height: 151, rotation: 0, imageRotation: 0 },
            { id: "3", x: 340, y: 339, width: 236, height: 151, rotation: 0, imageRotation: 0 },
            { id: "4", x: 865, y: 50, width: 298, height: 217, rotation: 0, imageRotation: 0 },
            { id: "5", x: 865, y: 276, width: 146, height: 215, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 276, width: 145, height: 215, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h4v2-03",
        name: "LA 03 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_03.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 153, y: 53, width: 170, height: 258, rotation: 0, imageRotation: 0 },
            { id: "2", x: 153, y: 318, width: 120, height: 172, rotation: 0, imageRotation: 0 },
            { id: "3", x: 280, y: 318, width: 233, height: 172, rotation: 0, imageRotation: 0 },
            { id: "4", x: 330, y: 53, width: 183, height: 125, rotation: 0, imageRotation: 0 },
            { id: "5", x: 330, y: 186, width: 183, height: 125, rotation: 0, imageRotation: 0 },
            { id: "6", x: 754, y: 86, width: 519, height: 369, rotation: 0, imageRotation: 0 }          
        ],
    },

    {
        id: "la-06-h4v2-04",
        name: "LA 04 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_04.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 113, y: 41, width: 287, height: 459, rotation: 0, imageRotation: 0 },
            { id: "2", x: 407, y: 277, width: 151, height: 223, rotation: 0, imageRotation: 0 },
            { id: "3", x: 407, y: 41, width: 151, height: 110, rotation: 0, imageRotation: 0 },
            { id: "4", x: 407, y: 159, width: 151, height: 110, rotation: 0, imageRotation: 0 },
            { id: "5", x: 836, y: 41, width: 355, height: 227, rotation: 0, imageRotation: 0 },
            { id: "6", x: 836, y: 276, width: 355, height: 226, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h4v2-05",
        name: "LA 05 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_05.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 85, y: 45, width: 290, height: 222, rotation: 0, imageRotation: 0 },
            { id: "2", x: 85, y: 276, width: 290, height: 221, rotation: 0, imageRotation: 0 },
            { id: "3", x: 383, y: 45, width: 290, height: 222, rotation: 0, imageRotation: 0 },
            { id: "4", x: 383, y: 276, width: 290, height: 221, rotation: 0, imageRotation: 0 },
            { id: "5", x: 681, y: 45, width: 289, height: 451, rotation: 0, imageRotation: 0 },
            { id: "6", x: 978, y: 45, width: 289, height: 451, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h4v2-06",
        name: "LA 06 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_06.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 56, y: 45, width: 319, height: 223, rotation: 0, imageRotation: 0 },
            { id: "2", x: 56, y: 276, width: 319, height: 222, rotation: 0, imageRotation: 0 },
            { id: "3", x: 383, y: 45, width: 289, height: 453, rotation: 0, imageRotation: 0 },       
            { id: "4", x: 681, y: 45, width: 319, height: 223, rotation: 0, imageRotation: 0 },
            { id: "5", x: 681, y: 276, width: 319, height: 222, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1008, y: 45, width: 290, height: 453, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h4v2-07",
        name: "LA 07 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_07.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 56, y: 45, width: 319, height: 223, rotation: 0, imageRotation: 0 },
            { id: "2", x: 56, y: 276, width: 319, height: 222, rotation: 0, imageRotation: 0 },
            { id: "3", x: 383, y: 45, width: 289, height: 453, rotation: 0, imageRotation: 0 },
            { id: "4", x: 681, y: 45, width: 290, height: 453, rotation: 0, imageRotation: 0 },           
            { id: "5", x: 979, y: 45, width: 319, height: 223, rotation: 0, imageRotation: 0 },
            { id: "6", x: 979, y: 276, width: 319, height: 222, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h4v2-08",
        name: "LA 08 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_08.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 35, y: 72, width: 256, height: 399, rotation: 0, imageRotation: 0 },
            { id: "2", x: 487, y: 72, width: 256, height: 399, rotation: 0, imageRotation: 0 },
            { id: "3", x: 750, y: 72, width: 567, height: 399, rotation: 0, imageRotation: 0 },
            { id: "4", x: 298, y: 72, width: 182, height: 128, rotation: 0, imageRotation: 0 },
            { id: "5", x: 298, y: 207, width: 182, height: 128, rotation: 0, imageRotation: 0 },
            { id: "6", x: 298, y: 343, width: 182, height: 128, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h4v2-09",
        name: "LA 09 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_09.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 35, y: 72, width: 567, height: 399, rotation: 0, imageRotation: 0 },
            { id: "2", x: 609, y: 72, width: 256, height: 399, rotation: 0, imageRotation: 0 },
            { id: "3", x: 872, y: 72, width: 256, height: 399, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1135, y: 72, width: 182, height: 128, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1135, y: 207, width: 182, height: 128, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1135, y: 343, width: 182, height: 128, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h4v2-10",
        name: "LA 10 - H4V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h4_v2_10.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 166, y: 39, width: 641, height: 463, rotation: 0, imageRotation: 0 },
            { id: "2", x: 815, y: 39, width: 154, height: 228, rotation: 0, imageRotation: 0 },
            { id: "3", x: 815, y: 275, width: 154, height: 227, rotation: 0, imageRotation: 0 },
            { id: "4", x: 976, y: 39, width: 211, height: 149, rotation: 0, imageRotation: 0 },
            { id: "5", x: 976, y: 196, width: 211, height: 149, rotation: 0, imageRotation: 0 },
            { id: "6", x: 976, y: 353, width: 211, height: 149, rotation: 0, imageRotation: 0 }
        ],
    }
];